<div class="modal-backdrop fade d-block d-lg-none" *ngIf="isVisibleAppDownload" [class.show]="isVisibleAppDownload"></div>
<div class="modal fade d-block d-lg-none" *ngIf="isVisibleAppDownload" 
 >
  <div class="modal-dialog signin-modal app-download-modal">
   
    <div class="modal-content">
        <button type="button" class="btn-close-1 close pull-right d-flex align-items-center jusity-content-center popup-close-btn"
        aria-label="Close" (click)="closeModal()">
        <i class="sprite-img-header-footer black-cross-circle"></i>
      </button>
        <img class="img-fluid promotion-image" src="./assets/images/app_promotion_img.svg" alt="app promotion image">
      <h5>Download our App and be the first to know about exclusive offers and updates.</h5>
      <a href="">
        <img class="img-fluid" src="./assets/images/google-play-badge.svg" alt="google play redirection button">
      </a>
 
    </div>
  </div>
</div>